import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import theme from './theme';
import { ThemeProvider } from '@mui/material';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { SnackbarProvider } from './components/common/SnackbarContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { createOptimizedQueryClient } from './utils/performanceConfig';

const root = (ReactDOM  as any).createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient = createOptimizedQueryClient();

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider>
            <App />
          </SnackbarProvider>
        </QueryClientProvider>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);